<template lang="html">
  <div>
    <sui-modal v-model="open" :closable="false">
      <sui-modal-header>
        <template v-if="content == 'modalPrivacy'">
          {{$t('labelPrivacy')}}
        </template>
        <template v-else-if="content == 'modalWithdrawal'">
          {{$t('labelWithdrawal')}}
        </template>
        <template>
          {{$t('labelConditions')}}
        </template>
      </sui-modal-header>
      <sui-modal-content scrolling>
        <sui-modal-description>
          <div v-if="content == 'modalPrivacy'">
            <ContentPrivacy />
          </div>
          <div v-else-if="content == 'modalWithdrawal'">
            <ContentWithdrawal />
          </div>
          <div v-else>
            <ContentConditions />
          </div>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click="toggle">{{$t('close')}}</sui-button>
      </sui-modal-actions>
    </sui-modal>
  </div>
</template>

<script>
  import ContentPrivacy from '@/views/static/Privacy.vue'
  import ContentWithdrawal from '@/views/static/Withdrawal.vue'
  import ContentConditions from '@/views/static/Conditions.vue'

  export default {
    name: 'Modal',
    props: ['content', 'open'],
    components: {
      ContentPrivacy,
      ContentWithdrawal,
      ContentConditions
    },
    methods: {
      toggle(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('closeModal')
      },
    },
  };</script>
